import FormWizard from './components/FormWizard.vue'
import TabContent from './components/TabContent.vue'
import WizardButton from './components/WizardButton.vue'
import WizardStep from './components/WizardStep.vue'
import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faAppleCrate, faUtensilsAlt, faTimesOctagon, faClipboardListCheck
} from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// fontawesome configuration
dom.watch(); // this will kick off the replacement of i to svg tags and configure a MutationObserver
config.autoReplaceSvg = 'nest'; // tell Font Awesome to nest the  SVG element under the I element.
config.autoAddCss = true;
config.searchPseudoElements = true; // Searches for elements with a Font Awesome CSS family-name and content property and replaces with inline SVG
//config.showMissingIcons = true; // if an icon cannot be found show an animated “missing” icon in its place

library.add(faClipboardListCheck,faAppleCrate, faUtensilsAlt, faTimesOctagon);

const VueFormWizard = {
  install(Vue) {
    Vue.component('font-awesome-icon',FontAwesomeIcon)
    Vue.component('form-wizard', FormWizard)
    Vue.component('tab-content', TabContent)
    Vue.component('wizard-button', WizardButton)
    Vue.component('wizard-step', WizardStep)
  }
}
// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueFormWizard)
}

export default VueFormWizard
export {
  FontAwesomeIcon,
  FormWizard,
  TabContent,
  WizardButton,
  WizardStep
}
